"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _strings = require("../../../constants/strings");

var _SearchBar = require("./SearchBar.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SearchBar = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SearchBar, _React$PureComponent);

  var _super = _createSuper(SearchBar);

  function SearchBar(props) {
    var _this;

    _classCallCheck(this, SearchBar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
      _this.setState({
        hasFocus: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
      _this.setState({
        hasFocus: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      _this.setState({
        searchTerm: e.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (e) {
      e.preventDefault();
      var _onSearch = _this.props.onSearch;
      var searchTerm = _this.state.searchTerm;

      _onSearch(searchTerm);
    });

    var initialSearchTerm = props.initialSearchTerm;
    _this.state = {
      hasFocus: false,
      searchTerm: initialSearchTerm || ''
    };
    return _this;
  }

  _createClass(SearchBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          placeholder = _this$props.placeholder;
      var _this$state = this.state,
          hasFocus = _this$state.hasFocus,
          searchTerm = _this$state.searchTerm;
      return /*#__PURE__*/_react.default.createElement(_SearchBar.Wrapper, {
        className: className,
        onSubmit: this.onSearch
      }, /*#__PURE__*/_react.default.createElement(_SearchBar.InputWrapper, null, /*#__PURE__*/_react.default.createElement(_SearchBar.StyledIcon, {
        colorTheme: hasFocus ? 'primary' : 'default',
        iconName: "search",
        dataTestId: "search-icon"
      }), /*#__PURE__*/_react.default.createElement(_SearchBar.SearchInput, {
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        "data-test-id": "search-input",
        placeholder: placeholder,
        value: searchTerm,
        onChange: this.handleChange
      })), /*#__PURE__*/_react.default.createElement(_SearchBar.SearchButton, {
        buttonType: "submit",
        buttonWidth: "fitText",
        colorTheme: "primary",
        dataTestId: "search-button"
      }, _strings.search));
    }
  }]);

  return SearchBar;
}(_react.default.PureComponent);

_defineProperty(SearchBar, "propTypes", {
  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Prop for providing an initial search term if so desired */
  initialSearchTerm: _propTypes.default.string,

  /** Method to execute on submit */
  onSearch: _propTypes.default.func.isRequired,

  /** placeholder text */
  placeholder: _propTypes.default.string
});

_defineProperty(SearchBar, "defaultProps", {
  className: '',
  initialSearchTerm: undefined,
  placeholder: ''
});

var _default = SearchBar;
exports.default = _default;